import { render, staticRenderFns } from "./manageObjective.vue?vue&type=template&id=a8ac5732&scoped=true"
import script from "./manageObjective.vue?vue&type=script&lang=js"
export * from "./manageObjective.vue?vue&type=script&lang=js"
import style0 from "./manageObjective.vue?vue&type=style&index=0&id=a8ac5732&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8ac5732",
  null
  
)

export default component.exports